module.exports = __webpack_public_path__ + "media/images/yardage_mark_4-01fd066a8e2ac2b74a358ce80309791f.png";